import xpath from 'xpath';
import * as h from '../helpers/helpers'
import { MISMODate } from '../classes/MISMODate';
import { MISMOMeasure } from '../classes/MISMOMeasure';
import { MISMOAmount } from '../classes/MISMOAmount';
export var xselect;

export function initHelpers() {
	xselect = xpath.useNamespaces({"ns": "http://www.mismo.org/residential/2009/schemas"});
}

export function selectSingleNode(node, xp) {
	try {
		if (node.Length === 1) node = node[0];
		//console.log("singleNode: ", xp, doc.length, doc);
		var n = xselect(xp, node, true);
		if (!n) return null;
		return n;
	} catch (error) {
		console.log("selectSingleNode ERROR: ", xp, node, error);
	}
	return null
}

export function selectNodes(node, xp) {
	const nodeList = [];
	try {
		var nodes = xselect(xp, node, false);
		if (!nodes) return nodeList;
		//console.log(nodes);
		nodes.forEach((cn) => {
			nodeList.push(cn);
		});
	} catch (error) {
		console.log("selectNodes ERROR: ", node, xp, error);
	}
	return nodeList;
}

export function getStringAttribute(node, name) {
	if (!node) {
		console.log("BAD NODE getting attributes: ", name)
		console.log(node);
		throw new Error("getStringAttribute");
		
	}
	const attrs = node.attributes;
	if (!attrs) return "";
	const len = attrs.length;
	for (var ix = 0; ix < len; ++ix) {
		var attr = attrs[ix];
		const n = attr.name;
		//console.log("attr.name: ", n, attr);
		if (n === name) return attr.nodeValue
	}
	return "";
}

export function getStringElement(node, xpath) {
	const element = selectSingleNode(node, xpath);
	//console.log("gse: ", xpath, element);
	if (!element) return "";
	var value = element.textContent;
	//console.log("gsev: ", value);
	return value;
}

export function getNumericElement(node, xpath) {
	const element = selectSingleNode(node, xpath);
	if (!element) return null;
	var value = element.textContent;
	//console.log("gsev: ", value);
	return value;
}

export function getIntegerElement(node, xpath) {
	const element = selectSingleNode(node, xpath);
	//console.log("gie: ", xpath, element);
	if (!element) return null;
	var value = Number(element.textContent);
	//console.log("gie value: ", value);
	return value;
}

export function getBooleanElement(node, xpath) {
	const element = selectSingleNode(node, xpath);
	if (!element) return null;
	var tf = element.textContent;
	var value = (tf === "true") ? true : false;
	//console.log("gbe: ", tf, value);
	return value;
}

export function getMISMOAmountElement(node, xpath) {
	const element = selectSingleNode(node, xpath);
	if (!element) return new MISMOAmount();
	var amt = element.textContent;
	var value = new MISMOAmount(amt);
	//console.log("gsev: ", value);
	return value;
}

export function getMISMODateElement(node, xpath) {
	const element = selectSingleNode(node, xpath);
	if (!element) return new MISMODate(null);

	var value = new MISMODate(element.textContent);
	//var value = h.formatDate(element.textContent);
	//console.log("gsev: ", value);
	return value;
}

export function getMISMOMeasureElement(node, xpath) {
    // Select the node using the namespace manager
    const element = selectSingleNode(node, xpath);
    if (!element) return new MISMOMeasure();

    // Get the inner text and parse it to an integer
    const value = element.textContent;
    const nValue = Number(value);

    // Iterate through the attributes
    for (let i = 0; i < element.attributes.length; i++) {
        const attrib = element.attributes[i];
        const name = attrib.name;
        const measure = h.toEnumText(attrib.nodeValue);

        // Check if the attribute name and value are not empty
        if (name && measure) {
            // Create a new Measure object
            const m = new MISMOMeasure(nValue, measure, MISMOMeasure.MeasureClass.None);

            // Set the measure class based on the attribute name
            switch (name) {
                case "LinearUnitOfMeasureType":
                    m.Class = MISMOMeasure.MeasureClass.Linear;
                    break;
                case "VolumeUnitOfMeasureType":
                    m.Class = MISMOMeasure.MeasureClass.Volume;
                    break;
                case "AreaUnitOfMeasureType":
                    m.Class = MISMOMeasure.MeasureClass.Area;
                    break;
								default:
                    m.Class = MISMOMeasure.MeasureClass.None;
									break;
            }

            return m;
        }
    }

    return new MISMOMeasure();
}


// Helper method to create namespace resolver
export function createNamespaceResolver(doc) {
  const nsmgr = {};
  // Add namespace mappings as needed
  nsmgr.lookupNamespaceURI = (prefix) => {
    if (prefix === "ns") {
      // Return the actual namespace URI used in your XML
      return (
        doc.documentElement.namespaceURI ||
        doc.documentElement.getAttribute("xmlns") ||
        "http://default-namespace-uri"
      );
    }
    return null;
  };
  return nsmgr;
}

